var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selected_payment_methods.length)?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('total-info'),expression:"'total-info'"}],attrs:{"variant":"outline-primary"}},[_c('i',{staticClass:"icon-info"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }